import * as React from 'react'

import { Box, SearchField, Skeleton } from '@factorialco/deprecated-design-system'

import EmployeeMultiFilters from 'modules/core/components/EmployeeMultiFilters'
import filterFields from 'modules/core/components/ListEmployees/_filters/filterFields'
import type LogicOperatorForm from 'modules/core/components/MultiFilters/Forms/LogicOperatorForm'
import type MultiFilterForm from 'modules/core/components/MultiFilters/Forms/MultiFilterForm'
import type { FilterOption as MultiFilterOption } from 'modules/core/components/MultiFilters/types'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import type FiltersForm from 'modules/core/lib/forms/Filters'
import i18n from 'modules/core/lib/i18n'

type EmployeeMultiFiltersProps = React.ComponentProps<typeof EmployeeMultiFilters>

interface Props {
  autofocus?: boolean
  filtersForm: FiltersForm
  search: string
  filters: MultiFilterForm[]
  logicOperator: LogicOperatorForm
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void
  onAddFilter: () => void
  onRemoveFilter: (index: number) => void
  onApplyFilters: () => void
  onCancel: () => void
  setChildPopoverOpen?: EmployeeMultiFiltersProps['setChildPopoverOpen']
}

const SearchBar = ({
  autofocus,
  filters,
  onSearch,
  search,
  logicOperator,
  onAddFilter,
  onRemoveFilter,
  onApplyFilters,
  onCancel,
  setChildPopoverOpen,
}: Props) => {
  const [fields, setFields] = React.useState<readonly MultiFilterOption[]>([])

  const { loading } = useAsyncData(async () => {
    const fields = await filterFields()

    setFields(fields)
  }, [])

  return (
    <Box
      paddingX="s16"
      paddingY="s12"
      width="full"
      background="grey200"
      flexDirection="row"
      gap="s8"
    >
      {loading && <Skeleton width="s96" height="s32" />}
      {!loading && (
        <EmployeeMultiFilters
          label={i18n.t('filters.multi_filters.title')}
          fields={fields}
          filters={filters}
          logicOperator={logicOperator}
          onAddFilter={onAddFilter}
          onRemoveFilter={onRemoveFilter}
          onApplyFilters={onApplyFilters}
          onCancel={onCancel}
          setChildPopoverOpen={setChildPopoverOpen}
        />
      )}
      <SearchField
        variant="big"
        placeholder={i18n.t('common.search')}
        autofocus={autofocus}
        onSearch={onSearch}
        search={search}
      />
    </Box>
  )
}

export default SearchBar
